import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ROUTES } from '../../../routing/routes'
import CUIT from '../../../styles/icons/cuit.svg'
import Facebook from '../../../styles/icons/facebook.svg'
import FooterLogo from '../../../styles/icons/footer-logo.svg'
import Instagram from '../../../styles/icons/instagram.svg'
import useWindowWidth from '../../../utils/use.window.width'
import { SupportModalComponent } from '../../ui/modals/support.modal.component'
import * as styled from './styled'

export const FooterComponent: React.FC = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const [openAccordion, setOpenAccordion] = useState<string | null>(null)
	const [isSupportOpen, setIsSupportOpen] = useState(false)
	const windowWidth = useWindowWidth()
	const isTablet = windowWidth <= 768
	const isMobile = windowWidth <= 530

	const accordionItems = [
		{
			title: 'Інфо-центр',
			subItems: [
				{ name: 'Нормативна база', route: ROUTES.NORMATIVE_BASE },
			    { name: 'Новини', route: ROUTES.NEWS },
			],
		},
		{ title: 'Мапа звернень', route: ROUTES.REQUESTS },
		{ title: 'Ремонтні роботи', route: ROUTES.REPAIR_WORK },
		{ title: 'Статистика', route: ROUTES.STATISTICS },
		{ title: 'Мапа Укриттів', route: 'https://ukryttya.zp.gov.ua/' },
	]

	return (
		<styled.Footer>
			<styled.FooterWrapper>
				<styled.FooterContainer>
					<styled.LeftColumn>
						<styled.FooterLogoContainer>
							<styled.FooterLogo src={FooterLogo} alt='log' />
							<span>Запорізька міська рада</span>
						</styled.FooterLogoContainer>
						{!isMobile && (
							<styled.FooterMenu>
								<styled.FooterMenuColumn>
									<styled.MenuTitle>Інфо-центр</styled.MenuTitle>
									<styled.Menulist>
										<styled.MenuItem onClick={() => navigate(ROUTES.NEWS)}>
											Новини
										
										</styled.MenuItem>
										<styled.MenuItem
											onClick={() => navigate(ROUTES.NORMATIVE_BASE)}
										>
											Нормативна база
											
										</styled.MenuItem>
									</styled.Menulist>
								</styled.FooterMenuColumn>

								<styled.RequestMenuColumn>
									<styled.FooterMenuColumn>
										<styled.Menulist>
											<styled.MenuItem
											   onClick={() => navigate(ROUTES.REQUESTS)}
											>
												Мапа звернень
											</styled.MenuItem>
										</styled.Menulist>
										<styled.Menulist>
											<styled.MenuItem
												onClick={() => navigate(ROUTES.REPAIR_WORK)}
											>
												Ремонтні роботи
											</styled.MenuItem>
											<styled.MenuItem
											onClick={() => navigate(ROUTES.STATISTICS)}
											>
												Статистика
												
											</styled.MenuItem>
											<styled.MenuItem onClick={() => window.open('https://ukryttya.zp.gov.ua/', '_blank', 'noopener,noreferrer')}>
												Мапа Укриттів
												</styled.MenuItem>
										</styled.Menulist>
									</styled.FooterMenuColumn>
								</styled.RequestMenuColumn>
							</styled.FooterMenu>
						)}

						{isMobile && (
							<styled.MobileAccordion>
								{accordionItems.map(item => (
									<styled.AccordionItem key={item.title}>
										<styled.AccordionHeader
											$active={item.route === location.pathname}
											//$isDev={item.isDevelopment && !item.subItems}
											onClick={() => {
												//if (item.isDevelopment && !item.subItems) return
												if (item.subItems) {
													setOpenAccordion(
														openAccordion === item.title ? null : item.title,
													)
													return
												}
												if (item.route) navigate(item.route)
											}}
										>
											{item.title}
											{/*
											{item.isDevelopment && !item.subItems && (
												<styled.DevTooltip>В розробці</styled.DevTooltip>
											)}
											*/}
											{item.subItems && (
												<styled.AccordionArrow
													$isOpen={openAccordion === item.title}
												/>
											)}
										</styled.AccordionHeader>

										{item.subItems && (
											<styled.AccordionBody
												$isOpen={openAccordion === item.title}
											>
												{item.subItems.map(sub => (
													<styled.AccordionSubItem
														key={sub.name}
														onClick={() => {
														if (!sub.route) return;
														navigate(sub.route);
														setOpenAccordion(null);
														}}
													>
														{sub.name}
													</styled.AccordionSubItem>
													))}
											</styled.AccordionBody>
										)}
									</styled.AccordionItem>
								))}
							</styled.MobileAccordion>
						)}
					</styled.LeftColumn>

					<styled.RightColumn>
						{!isMobile && (
							<styled.HelpColumn>
								<styled.HelpWrapper>
									<styled.HelpText>
										Виникли труднощі під час користування вебпорталом?
									</styled.HelpText>
									<styled.FooterButton onClick={() => setIsSupportOpen(true)}>
										Напишіть нам
									</styled.FooterButton>
									<SupportModalComponent
										isOpen={isSupportOpen}
										onClose={() => setIsSupportOpen(false)}
									/>
								</styled.HelpWrapper>
							</styled.HelpColumn>
						)}

						<styled.TechnicalSupportColumn>
							<styled.TechnicalSupportTitle>
								Технічне забезпечення{' '}
							</styled.TechnicalSupportTitle>
							<styled.TechnicalSupportLogo 
								as="a" 
								href="https://itmc.zp.gov.ua/" 
								target="_blank" 
								rel="noopener noreferrer"
								style={{ textDecoration: 'none', color: 'inherit' }} 
								>
									<styled.CUITLogo src={CUIT} alt='logo' />
									<styled.Text>
										Центр <br />
										Управління <br />
										Інформаційними <br />
										Технологіями
									</styled.Text>
								</styled.TechnicalSupportLogo>
							{isMobile && (
								<styled.HelpColumn>
									<styled.HelpWrapper>
										<styled.HelpText>
											Виникли труднощі під час користування вебпорталом?
										</styled.HelpText>
										<styled.FooterButton onClick={() => setIsSupportOpen(true)}>
											Напишіть нам
										</styled.FooterButton>
										<SupportModalComponent
											isOpen={isSupportOpen}
											onClose={() => setIsSupportOpen(false)}
										/>
									</styled.HelpWrapper>
								</styled.HelpColumn>
							)}
							<styled.TechnicalSupportText>
								Слідкуйте за каналами КП «ЦУІТ» у соціальних мережах:
								{isTablet && (
									<styled.TechnicalSocials>
										<a
											href='https://www.instagram.com/itmc_zp/'
											target='_blank'
											rel='noopener noreferrer'
										>
											<styled.SocialsIcon src={Instagram} alt='instagram' />
										</a>
										<a
											href='https://www.facebook.com/ITMCzp'
											target='_blank'
											rel='noopener noreferrer'
										>
											<styled.SocialsIcon src={Facebook} alt='facebook' />
										</a>
									</styled.TechnicalSocials>
								)}
							</styled.TechnicalSupportText>

							{!isTablet && (
								<styled.TechnicalSocials>
									<a
										href='https://www.instagram.com/itmc_zp/'
										target='_blank'
										rel='noopener noreferrer'
									>
										<styled.SocialsIcon src={Instagram} alt='instagram' />
									</a>
									<a
										href='https://www.facebook.com/ITMCzp'
										target='_blank'
										rel='noopener noreferrer'
									>
										<styled.SocialsIcon src={Facebook} alt='facebook' />
									</a>
								</styled.TechnicalSocials>
							)}
						</styled.TechnicalSupportColumn>
					</styled.RightColumn>
				</styled.FooterContainer>
			</styled.FooterWrapper>
			<styled.SubFooter>
				<styled.SubFooterContainer>
					<styled.SubFooterText>
						<span>
							© 2024 -2026 КОМУНАЛЬНЕ ПІДПРИЄМСТВО "ЦЕНТР УПРАВЛІННЯ
							ІНФОРМАЦІЙНИМИ ТЕХНОЛОГІЯМИ".
						</span>{' '}
						Всі права захищені.
					</styled.SubFooterText>
					<styled.SubFooterLink
						to='/privacy-policy'
						target='_blank'
						rel='noopener noreferrer'
					>
						Політика конфіденційності
					</styled.SubFooterLink>
				</styled.SubFooterContainer>
			</styled.SubFooter>
		</styled.Footer>
	)
}
